import { IApiRequest, IApiResponse, fetchApi } from '../../core/auth/fetchApiHelper';
import { logger } from '../../core/diagnostics/logger';
import { processConfig } from '../../environment.constants';

import { ICartModel, ICheckOutCartModelResponse, IOrderModel } from './shopping.state.interface';

export interface ISessionModel {
  readonly userAzureADId: string;
  readonly emailAddress: string;
  readonly companyName: string;
  readonly ipAddress: string;
  readonly userAgent: string;
  readonly sessionStartTime: string;
  readonly sessionEndTime?: string;
}

export interface ICartResponseModel {
  readonly invalidProductIdentifiers: string[];
  readonly updatedCart: ICartModel;
}

export const createSession = async (model: ISessionModel): Promise<number | undefined> => {
  const request: IApiRequest = {
    url: `${processConfig.baseGatewayUrl}/shopping-svc/v1.0/Analytics/create-session`,
    method: 'POST',
    contentType: 'application/json',
    requireAccessToken: true,
    body: model
  };

  const response = await fetchApi<number>(request);
  return response.payload;
};

export const updateSessionEndTime = async (sessionId: number): Promise<void> => {
  const request: IApiRequest = {
    url: `${processConfig.baseGatewayUrl}/shopping-svc/v1.0/Analytics/update-session-end-time`,
    method: 'POST',
    contentType: 'application/json',
    requireAccessToken: true,
    body: { sessionId }
  };

  await fetchApi(request);
};

export const updateItems = async (cartModel: ICartModel): Promise<IApiResponse<ICartResponseModel>> => {
  try {
    const request: IApiRequest = {
      url: `${processConfig.baseGatewayUrl}/shopping-svc/v1.0/Cart/cart-update-items`,
      method: 'POST',
      contentType: 'application/json',
      requireAccessToken: true,
      body: cartModel
    };

    const response = await fetchApi<ICartResponseModel>(request);
    return response;
  } catch (e) {
    logger.error('error updating cart items', e as Error);
    throw e;
  }
};

export const checkout = async (orderModel: IOrderModel) => {
  const request: IApiRequest = {
    url: `${processConfig.baseGatewayUrl}/shopping-svc/v1.0/Cart/cart-checkout`,
    method: 'POST',
    contentType: 'application/json',
    requireAccessToken: true,
    body: orderModel
  };

  const response = await fetchApi<ICheckOutCartModelResponse>(request);
  return response.payload;
};

export const getIsCartExpired = async (userId: string) => {
  const request: IApiRequest = {
    url: `${processConfig.baseGatewayUrl}/shopping-svc/v1.0/Cart/get-is-cart-expired-by-user?userId=${userId}`,
    method: 'GET',
    contentType: 'application/json',
    requireAccessToken: true
  };

  const response = await fetchApi(request);
  return response;
};

export const getCartItems = async (userId: string) => {
  const request: IApiRequest = {
    url: `${processConfig.baseGatewayUrl}/shopping-svc/v1.0/Cart/get-cart-items?userId=${userId}`,
    method: 'GET',
    contentType: 'application/json',
    requireAccessToken: true
  };

  const response = await fetchApi(request);
  return response;
};
